export const getFirstName = ({ name }: { name?: string }): string => (name ?? '').split(' ')[0];
